import { Component, lazy, Suspense, type ReactNode } from 'react';

/** The staff screens that show the notice, and where each one's quiet corner is. */
export type StaffNoticeScreen = 'tpv' | 'cocina' | 'servicio';

// Loaded with the first staff screen: the card's styles stay out of the shell's own chunk.
const StaffNoticeCorner = lazy(() => import('./staff-notice-corner').then((module) => ({ default: module.StaffNoticeCorner })));

/** A notice that cannot load or draw takes nothing else with it: the screen goes on without it. */
class QuietBoundary extends Component<{ readonly children: ReactNode }, { readonly failed: boolean }> {
  override state = { failed: false };
  static getDerivedStateFromError() {
    return { failed: true };
  }
  override render() {
    return this.state.failed ? null : this.props.children;
  }
}

/**
 * Mounts the staff notice beside TPV, Cocina or Servicio without touching the screen itself: in the TPV's reserved
 * place under its table list, bottom right on Cocina (larger, for the wall) and Servicio.
 */
export function StaffNoticeMount({ screen }: { readonly screen: StaffNoticeScreen }) {
  return <QuietBoundary>
    <Suspense fallback={null}>
      <StaffNoticeCorner placement={screen === 'tpv' ? 'start' : 'end'} wall={screen === 'cocina'} />
    </Suspense>
  </QuietBoundary>;
}
